module.exports = __webpack_public_path__ + "static/media/hcc-480x360@2x.5d369295.png";